import React from 'react'
import { Link } from 'gatsby'

import * as blogCategoriesStyles from './blogCategories.module.scss'
import Food from '../images/restaurant.svg'
import Health from '../images/heartbeat.svg'
import Travel from '../images/aircraft.svg'

const BlogCategories = () => {
    return (
        <div className={blogCategoriesStyles.background}>
            <div className={blogCategoriesStyles.container}>
                <h2 className={blogCategoriesStyles.heading}>Read</h2>
                <h3 className={blogCategoriesStyles.subheading}>Articles by topic</h3>
                <div className={blogCategoriesStyles.blocks}>
                    <Link to={`/travel`}>
                        <div className={blogCategoriesStyles.block} id={blogCategoriesStyles.blockTravel}>
                            <div className={blogCategoriesStyles.blockOverlay}></div>
                            <h3 className={blogCategoriesStyles.blockHeading}>
                                <Travel className={blogCategoriesStyles.icon} /> Travel
                            </h3>
                        </div>
                    </Link>    
                    <Link to={`/vegan-life/recipes`}>
                        <div className={blogCategoriesStyles.block} id={blogCategoriesStyles.blockRecipes}>
                            <div className={blogCategoriesStyles.blockOverlay}></div>
                            <h3 className={blogCategoriesStyles.blockHeading}>
                                <Food className={blogCategoriesStyles.icon}  />Vegan Recipes
                            </h3>
                        </div>
                    </Link>
                    <Link to={`/vegan-life/health`}>
                        <div className={blogCategoriesStyles.block} id={blogCategoriesStyles.blockHealth}>
                            <div className={blogCategoriesStyles.blockOverlay}></div>
                            <h3 className={blogCategoriesStyles.blockHeading}>
                                <Health className={blogCategoriesStyles.icon}  />Vegan Health
                            </h3>
                        </div>
                    </Link>    
                </div>
            </div>
        </div>
    )
}

export default BlogCategories